/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import * as React from 'react';
import PropTypes from 'prop-types';
import { LoginForm } from './LoginForm';
import Logo from '../Header/Logo.svg';
import '../../containers/ResetPassword/ResetPassword.css';
import './Login.css';
import crowdfunderImage from '../../containers/ResetPassword/crowdfunder.png';
import circlefixImage from '../../containers/ResetPassword/circlefix.png';
import nikeImage from '../../containers/ResetPassword/nike.png';
import yahooImage from '../../containers/ResetPassword/yahoo.png';
import briogeoImage from '../../containers/ResetPassword/briogeo.png';
import wavemakerImage from '../../containers/ResetPassword/wavemaker.png';
import instyleImage from '../../containers/ResetPassword/instyle.png';
import ssImage from '../../containers/ResetPassword/76.png';

export const Login = ({ onSubmit }) => (
  <div className="page login-page">
    <div className="logo">
      <a href="https://dreamitreel.com" className="navbar-brand">
        <img alt="Dream it Reel Logo" src={Logo} />
      </a>
    </div>
    <div className="reset-password">
      <div className="reset-password__form-container">
        <LoginForm onSubmit={onSubmit} />
      </div>
    </div>
    <div className="image-container">
      <div className="content-container">
        <div className="image-container__advanced-info">
          <div className="advanced-text-info">
            <h1 className="text font-weight-bold t-40">Video creation made simple</h1>
            <ul>
              <li>A simple, streamlined process to get things started</li>
              <li>Creative talent spanning from concept to creation</li>
              <li>Next level project feedback and collaboration</li>
            </ul>
          </div>
          <div className="advanced-images">
            <div className="image-column">
              <div className="image-block">
                <img src={yahooImage} />
              </div>
              <div className="image-block">
                <img src={briogeoImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={crowdfunderImage} />
              </div>
              <div className="image-block">
                <img src={circlefixImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={nikeImage} />
              </div>
              <div className="image-block">
                <img src={ssImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={instyleImage} />
              </div>
              <div className="image-block">
                <img src={wavemakerImage} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Login.propTypes = {
  handleUpdateActiveTab: PropTypes.func,
  clientTabActive: PropTypes.bool,
  onSubmit: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Login/Login.js